<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    min-width="290px"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        :color="color"
        :disabled="disabled"
        :rules="[ validDateRule ]"
        prepend-icon="mdi-calendar"
        @keydown="menu = false"
        @change="dateChanged"
        v-on="on"
      />
    </template>

    <v-date-picker
      v-model="date"
      :color="color"
      :error-messages="errorMessages"
      :disabled="disabled"
      scrollable
      @change="dateChanged"
      @input="menu = false"
    >
      <v-spacer />

      <v-btn
        :color="color"
        large
        @click="menu = false"
      >
        Cancel
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    name: 'ResourceSelect',

    props: {
      color: {
        type: String,
        default: 'primary',
      },
      label: {
        type: String,
        default: null,
      },
      dateValue: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      errorMessages: {
        type: String,
        default: null,
      },
    },

    data: () => ({
      menu: false,
    }),

    computed: {
      date: {
        get () {
          let dateString = null
          if (this.dateValue) {
            dateString = (new Date(this.dateValue)).toISOString().substr(0, 10)
          }
          return dateString
        },
        set (val) {
        },
      },
    },

    methods: {
      dateChanged (val) {
        let newDate = null
        if (this.validDate(val)) {
          this.dateValue = val
          newDate = (new Date(val)).toISOString()
        }
        this.$emit('update:dateValue', newDate)
        this.$emit('change', newDate)
      },

      validDateRule (val) {
        return this.validDate(val) || !val || 'Invalid date.'
      },

      validDate (val) {
        let valid = false

        if (val) {
          let parseResults = Date.parse(val)

          valid = !isNaN(parseResults)

          if (valid) {
            const dt = new Date(val)
            parseResults = dt.getDate()
            valid = !isNaN(parseResults)
          }
        }

        return valid
      },
    },
  }
</script>
